<template>
  <div v-show="isVisible">
    <div class="checkbox">
      <v-checkbox
        color="primary"
        :class="{
          'checkbox-right': !item && !schema.left,
          'mb-4': schema.left,
        }"
        :disabled="isDisabled"
        type="checkbox"
        v-model="localValue"
        @keydown.native.enter.stop="toggleField"
      >
        <template v-slot:label>
          <div>
            <span>{{ schema.label || schema.title }}</span>
            <v-tooltip v-if="schema.help" bottom>
              <template v-slot:activator="{ on }" @click.stop>
                <v-icon
                  x-small
                  v-on="on"
                  color="primary"
                  class="ml-1 mb-1 help-icon"
                >
                  help
                </v-icon>
              </template>
              {{ schema.help }}
            </v-tooltip>
          </div>
        </template>
      </v-checkbox>
      <v-alert
        v-if="getAlertMessage"
        type="info"
        border="left"
        class="mt-2 mb-0 checkbox-alert"
        icon="mdi-information-outline"
      >
        {{ getAlertMessage }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import GenericField from './GenericField';

export default {
  name: 'CheckboxField',
  mixins: [GenericField],
  methods: {
    toggleField() {
      this.localValue = !this.localValue;
    },
  },
};
</script>

<style lang="less">
.field-block {
  .CheckboxField {
    .help-icon {
      display: none;
    }
  }
}

.checkbox-alert {
  font-size: 1rem;
  padding: 6px 8px !important;

  .v-alert__icon {
    font-size: 18px !important;
    margin-right: 8px !important;
  }
}
</style>
